import React from 'react';
import { useLanguage } from '../../App';
import footerBg from '../../Assets/Footer/mainfooter.png';
import footerLogo from '../../Assets/Footer/logofooter.png';
import faceIcon from '../../Assets/Footer/face.png';
import instaIcon from '../../Assets/Footer/Instagram.png';
import callIcon from '../../Assets/Footer/call.png';
import locationIcon from '../../Assets/Footer/location.png';
import smsIcon from '../../Assets/Footer/sms.png';

const Footer = () => {
  const { t, language } = useLanguage();
  const isArabic = language === 'ar';

  return (
    <footer 
      className="relative w-full min-h-fit bg-cover bg-center flex items-center py-12 md:py-20 overflow-hidden mt-20"
      style={{ 
        backgroundImage: `url(${footerBg})`,
        backgroundSize: 'cover' 
      }}
    >
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="container mx-auto px-6 lg:px-16 relative z-10">
        <div className={`flex flex-col md:flex-row md:justify-start gap-12 lg:gap-20 ${isArabic ? 'rtl' : 'ltr'}`}>
          
          <div className="flex flex-col items-center md:items-center text-center max-w-[320px] mx-auto md:mx-0">
            <img 
              src={footerLogo} 
              alt="Logo" 
              className="w-[150px] md:w-[180px] h-auto object-contain mb-6"
            />
            <p className="text-[#CFCFCF] font-alexandria font-light text-[14px] md:text-[16px] leading-relaxed mb-6">
              {t('footer.description')}
            </p>
            <div className="w-20 h-[1px] bg-[gray] mb-8 opacity-60"></div>
            <div className="flex gap-5 justify-center">
              <a href="https://www.facebook.com/profile.php?id=61578646017316" target="_blank" rel="noreferrer" className="hover:scale-110 transition-transform">
                <img src={faceIcon} alt="facebook" className="w-6 h-6 md:w-7 md:h-7" />
              </a>
              <a href="https://www.instagram.com/sb_group.sy" target="_blank" rel="noreferrer" className="hover:scale-110 transition-transform">
                <img src={instaIcon} alt="instagram" className="w-7 h-7 md:w-9 md:h-9" />
              </a>
            </div>
          </div>

          <div className={`flex flex-col items-center md:items-start ${isArabic ? 'md:mr-10' : 'md:ml-10'}`}>
            <h3 className="text-[#1A4D90] font-alexandria font-semibold text-[17px] md:text-[19px] mb-6 whitespace-nowrap">
              {t('footer.exploreTitle')}
            </h3>
            <ul className="flex flex-col gap-4 text-white font-alexandria font-light text-[14px] md:text-[15px] items-center md:items-start">
              <li><a href="#home" className="hover:text-[#1A4D90] transition-colors">{t('navbar.home')}</a></li>
              <li><a href="#about" className="hover:text-[#1A4D90] transition-colors">{t('navbar.about')}</a></li>
              <li><a href="#services" className="hover:text-[#1A4D90] transition-colors">{t('navbar.services')}</a></li>
              <li><a href="#features" className="hover:text-[#1A4D90] transition-colors">{t('navbar.features')}</a></li>
              <li><a href="#why-us" className="hover:text-[#1A4D90] transition-colors">{t('navbar.whyUs')}</a></li>
            </ul>
          </div>

          <div className={`flex flex-col items-center md:items-start flex-1 ${isArabic ? 'md:mr-auto' : 'md:ml-auto'} max-w-[450px]`}>
            <h3 className="text-[#1A4D90] font-alexandria font-semibold text-[17px] md:text-[19px] mb-6">
              {t('footer.contactTitle')}
            </h3>
            
            <div className="flex flex-col gap-4 w-full items-center md:items-start">
              <div className="flex flex-col items-center md:items-start gap-2 bg-white/5 p-4 rounded-xl w-full border border-white/5 transition-all hover:bg-white/10">
                <div className="flex items-center gap-2">
                  <img src={locationIcon} alt="" className="w-4 h-4 opacity-70" />
                  <span className="text-[#CFCFCF] text-[13px] md:text-[14px] font-medium">{t('footer.addressDamascus')}</span>
                </div>
                <div className="w-full h-[1px] bg-white/10 my-1 md:max-w-[150px]"></div>
                <div className="flex items-center gap-2">
                  <img src={callIcon} alt="" className="w-4 h-4" />
                  <a href="tel:+963943523797" dir="ltr" className="text-white hover:text-[#1A4D90] text-[14px] md:text-[15px] transition-colors font-light">+963 943 523 797</a>
                </div>
              </div>

              <div className="flex flex-col items-center md:items-start gap-2 bg-white/5 p-4 rounded-xl w-full border border-white/5 transition-all hover:bg-white/10">
                <div className="flex items-center gap-2">
                  <img src={locationIcon} alt="" className="w-4 h-4 opacity-70" />
                  <span className="text-[#CFCFCF] text-[13px] md:text-[14px] font-medium">{t('footer.addressAleppo')}</span>
                </div>
                <div className="w-full h-[1px] bg-white/10 my-1 md:max-w-[150px]"></div>
                <div className="flex items-center gap-2">
                  <img src={callIcon} alt="" className="w-4 h-4" />
                  <a href="tel:+963982918816" dir="ltr" className="text-white hover:text-[#1A4D90] text-[14px] md:text-[15px] transition-colors font-light">+963 982 918 816</a>
                </div>
              </div>

              <div className="flex items-center gap-3 justify-center md:justify-start bg-white/5 p-4 rounded-xl w-full border border-white/5 transition-all hover:bg-white/10">
                <img src={smsIcon} alt="" className="w-4 h-4 md:w-5 md:h-5" />
                <a href="mailto:info@sb-groups.net" className="text-white hover:text-[#1A4D90] text-[14px] md:text-[15px] transition-colors">info@sb-groups.net</a>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <a href="https://icrcompany.net/" target="_blank" rel="noreferrer" className="group inline-block">
            <p className="text-[#CFCFCF] text-[11px] md:text-[13px] font-light transition-colors group-hover:text-white">
              {t('footer.rights')} <span className="text-[#1A4D90] font-bold group-hover:underline">ICR</span>
            </p>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;